// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QivR","badges":"styles_badges__3Kdlk"};